import { useMemo, useState } from 'react';
import { useQuery } from 'convex/react';
import { api } from '../../../../convex/_generated/api';
import { useLanguage } from '../../../contexts/useLanguage';
import type { Accommodation } from '../../../types';
import { useWebDesignedCart } from '../../../contexts/WebDesignedCartContext';
import { getStayName } from '../utils';
import { mapListWithUrlsToAccommodations, type AccommodationListWithUrlsRow } from '../staysPageAccommodationFromConvex';
import { isStayReservable } from '../../../lib/stayReservation';

export type HomeAccommodationTab = 'yourte' | 'chalet' | 'unite_rangée';

export function useHomeAccommodation() {
  const { t } = useLanguage();
  const cart = useWebDesignedCart();
  const listWithUrls = useQuery(api.accommodations.listWithImageUrls);

  const accommodations = useMemo(() => {
    if (!listWithUrls?.length) return [];
    return mapListWithUrlsToAccommodations(listWithUrls as AccommodationListWithUrlsRow[]);
  }, [listWithUrls]);

  const [activeTab, setActiveTab] = useState<HomeAccommodationTab>('chalet');
  const featuredStays = accommodations.filter((stay) => stay.type === activeTab);

  const onBookStay = (stay: Accommodation) => {
    if (!isStayReservable(stay)) return;
    cart?.openReservationForm('accommodation', stay.id, getStayName(stay.name) || stay.name, stay.pricePerNight, {
      taxeHebergementEnabled: stay.taxeHebergementEnabled !== false,
    });
  };

  return { t, activeTab, setActiveTab, featuredStays, onBookStay };
}
